import {Button} from '@nlabs/gothamjs';
import {BookOpen, Clapperboard, Send} from '@nlabs/gothamjs/icons';

import ufatPortalSigninHero from '../../assets/ufat-portal-signin-hero.png';
import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {PortalPreviewCard} from '../../components/PortalPreviewCard';
import {Section} from '../../components/Section';
import {ServiceCard} from '../../components/ServiceCard';
import {navigate} from '../../lib/navigation';
import {buttonDarkPrimary, buttonOutlineDark, card, cardContent, cardTitle, gridThree, paragraphMuted} from '../../lib/styles';
import {Route} from '../../types/routes';

export const Creators = ({route}: {route: Route}) => (
  <Page route={route}>
    <Hero
      actions={(
        <>
          <Button className={buttonDarkPrimary} onClick={() => navigate('/creators')}>Pitch Your Book</Button>
          <Button className={buttonOutlineDark} onClick={() => navigate('/portal')}>Creator Portal</Button>
        </>
      )}
      backgroundImage={ufatPortalSigninHero}
      copyTone="dark"
      imageLabel="Creator publishing placeholder image"
      kicker="Publish with UFAT Studios"
      subtitle="For creators who need a publishing partner for hardcover books, softcover editions, digital books, and story-driven media."
      title="Bring us the manuscript. We will help shape the publishing path."
      tone="cyan"
    />
    <Section className="nx-section-creators" title="What creators can pitch">
      <div className={gridThree}>
        <ServiceCard body="Hardcover, softcover, and digital editions for finished manuscripts, illustrated projects, and creative nonfiction." icon={<BookOpen />} title="Books in multiple formats" />
        <ServiceCard body="Author brands, launch pages, reader-facing collateral, and companion material for stories with a larger creative world." icon={<Clapperboard />} title="Media-ready projects" />
        <ServiceCard body="A practical submission path now, with account-based uploads and production tracking planned for phase 2." icon={<Send />} title="Simple first contact" />
      </div>
    </Section>
    <Section className="nx-section-creators-alt" title="How the pitch flow works">
      <div className="grid gap-[18px] min-[841px]:grid-cols-[1fr_.9fr]">
        <div className="grid gap-[18px]">
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>1. Send the project shape</h3>
              <p className={paragraphMuted}>Tell us the title, category, format goals, current draft stage, and why the book or media project belongs with UFAT Studios.</p>
            </div>
          </div>
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>2. Share sample material</h3>
              <p className={paragraphMuted}>Use a private link for a proposal, sample chapters, lookbook, manuscript PDF, or digital media preview. Direct PDF upload can come later in the portal.</p>
            </div>
          </div>
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>3. We review fit and next steps</h3>
              <p className={paragraphMuted}>We can respond with questions, request more material, or move the project toward editorial, production, print, and digital planning.</p>
            </div>
          </div>
        </div>
        <PortalPreviewCard />
      </div>
    </Section>
  </Page>
);
